import { render, staticRenderFns } from "./ArchiveSection.vue?vue&type=template&id=7c995fdc&scoped=true&"
import script from "./ArchiveSection.vue?vue&type=script&lang=js&"
export * from "./ArchiveSection.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveSection.vue?vue&type=style&index=0&id=7c995fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c995fdc",
  null
  
)

export default component.exports